import hash from "../hash";
import { bootbox } from "../B2bTools";
import { createApp } from "vue";
import DropzoneUnHelper from "./composant/DropzoneUnHelper";
import b2bDropdownEllipses from "./composant/b2bDropdownEllipses";
import { $$Dic } from "../B2bTools";
import { may, toDate, traduit } from "./composant/b2bLangue";
import htmlEnv from "./env.html";
import Store from "../Store";
//
function triSection(linelists) {
	const regroupements = {};
	for (const linelist of linelists) {
		const regroupement = linelist.regroupement || "test";

		if (!regroupements[regroupement]) {
			regroupements[regroupement] = { k: regroupement, rows: [] };
		}
		regroupements[regroupement].rows.push(linelist);
	} 
	const array = [];
	for (const key in regroupements) {
		regroupements[key].rows.sort(function (a, b) { return (a.sortkey || "").localeCompare(b.sortkey) })
		array.push(regroupements[key]);
	}
	//
	array.sort(function (a, b) { return a.k.localeCompare(b.k) });
	return array;
}

const jsEnv = ({
	topbar: true,
	url: function (echangeur) {
		echangeur.addAction('b2b.env.get', echangeur.hash, '', 'data');

		const k = echangeur.hash.u;
		// console.log(`jsEnv k ${k}`);
		if (k) echangeur.addAction('b2b.env.edit', { k }, '', 'universe');
	},
	 onLoad: async function (echangeur) {
		const THIS = this;

		let CTX = Store.get("CTX"); 
		await CTX.update(null, true);


		const env = echangeur.data.env;
		THIS.$$dic = new $$Dic(echangeur.data.$$dic);
		// console.log(env.linelists)
		const app = createApp({
			components: {
				'dropdown-ellipses': b2bDropdownEllipses
			},
			data: function () {
				const mains = env.linelists.filter(u => !u.parent);
				const customs = env.linelists.filter(u => u.parent);
				//
				return {
					environnement: {
						k: env.k,
						v: env.v,
						tocK: env.tocK,
						_id: env._id,
						//
						sectionMains: 	triSection(mains),
						sectionCustoms: triSection(customs),
					},
					universe: echangeur.universe,
					modesimple: env.modesimple,
					modeVignette: (env.modesimple) ? true : false,
					tabs: [
						{ k: "Main Linelists" },
						{ k: "Custom Linelists" }
					],
					selectedIndex: 0,
					sortAlphaSens: -1, 
					sortDateCreatedSens: -1,
				}
			},
			computed: {
			},
			methods: {
				triAlphabetic() {
					if (this.sortDateCreatedSens === 1) this.triDateCreated();
					this.sortAlphaSens = -this.sortAlphaSens;
					this.environnement.sectionCustoms.forEach(element => {
						element.rows.sort((a, b) => (a.customtitle || "").localeCompare(b.customtitle) * this.sortAlphaSens)
					});
					this.environnement.sectionMains.forEach(element => {
						element.rows.sort((a, b) => (a.title || "").localeCompare(b.title) * this.sortAlphaSens)
					});
				},
				triDateCreated() {
					if (this.sortAlphaSens === 1) this.triAlphabetic();
					this.sortDateCreatedSens = -this.sortDateCreatedSens;
					this.environnement[this.selectedIndex === 0 ? 'sectionMains' : 'sectionCustoms'].forEach(element => {
						element.rows.sort((a, b) => (a.x.c.date || "").localeCompare(b.x.c.date) * this.sortDateCreatedSens)
					})
				},
				showTab(index) {
					this.selectedIndex = index;
				},
				toV(value) {
					return (value || "no value").split("|").pop();
				},
				chaine(form, e) {
					hash.lance(form, { k: e })
				},
				may(key) {
					return may(key);
				},
				linelistLance(form) {
					hash.lance("linelist", { _id: form._id, env: env.k })
				},
				linelistSelectProducts(form) {
					hash.lance("linelist", { _id: form._id, env: env.k, preview: true })
				},
				linelistEditer(form) {
					if (form.parent) {
						hash.lance("customEdit", { _id: form._id, env: env.k })
					} else {
						hash.lance("linelistEdit", { _id: form._id, env: env.k })
					}
				},
				universeEdit(universe, key) {
					const param = { k: universe.k }
					if (key) param.key = key

					hash.lance("universeEdit", param)
				},
				customBrandname(form) {
					hash.lance("customBrandname", { _id: form._id, env: env.k })
				},
				customEdit(form) {
					hash.lance("customEdit", { _id: form._id, env: env.k })
				},
				linelistCreer(form) {
					hash.lance("linelistEdit", { env: env.k, u:Store.get('getURUL')() })
				},
				linelistDuplicate(form) {
					hash.lance("linelistEdit", { duplicate: form._id, env: env.k })
				},
				customDuplicate(form) {
					hash.lance("customEdit", { duplicate: form._id, env: env.k })
				},
				linelistCustom(form) {
					hash.lance("customEdit", { duplicate: form._id, env: env.k })
				},
				linelistDelete(form) {
					const thisParent = this;
					bootbox.confirm(
						{
							title: 'Remove Linelist',
							message: `Are you sure to <b> ${form.title} </b>`
						},
						async function () {
							const retour = await THIS.rest("b2b.linelist.del", { _id: form._id });
							//
							if (retour.ok) {
								// const linelists = data.env.linelists;
								// const mains = linelists.filter(u => !u.parent);
								// const customs = linelists.filter(u => u.parent);
								// this.vm.$data.environnement.sectionMains = triSection(mains);
								// this.vm.$data.environnement.sectionCustoms = triSection(customs);
								//
								const data = await THIS.rest('b2b.env.get', echangeur.hash);
								//
								const linelists = data.env.linelists;
								const mains = linelists.filter(u => !u.parent);
								const customs = linelists.filter(u => u.parent);
								thisParent.environnement.sectionMains = triSection(mains);
								thisParent.environnement.sectionCustoms = triSection(customs);
							}
						})
				},
				toBrandname(k) {
					return THIS.$$dic.brandname(k).v;
				},
				toBrandnames(array) {
					return array.map(u => this.toBrandname(u))
				},
				toDate(value) {
					return toDate(value);
				},
				toGroup(k) {
					return THIS.$$dic.group(k).v;
				},
				toGroups(array) {
					return array.map(u => this.toGroup(u))
				},
				linelistStyle(linelist, size) {
					// permet d'ajouter l'image en fond 
					if (linelist.visuel && linelist.visuel.front) {
						let vId = linelist.visuel._id;
						if (!vId) vId = (linelist.parent) ? linelist.parent : linelist._id;
						const url = "image/linelist/" + vId + "_" + linelist.visuel.front;
						return 'background-image: url(' + url + ')';
					} else {
						//const imagePardefaut = `assets/img/no-img-${size}.png`
						const imagePardefaut = `assets/img/logo-red.png`
						return `background-image: url('${imagePardefaut}')`
					}
				},
				universeStyle(universe) {
					if (universe.media) {
						const image = "image/universe/" + universe.media
						return `background-image: url('${image}')`
					} else {
						const imagePardefaut = `assets/img/logo-red.png`
						return `background-image: url('${imagePardefaut}')`
					}
				},

				linelistEditerVisuel(item) {
					//
					const tempName = "linelist_" + item._id + "_" + "_head"
					//
					const onSuccess = async function (data) {
						// console.log(data);
						const a = await THIS.rest("b2b.linelist.changeimg", { _id: item._id, front: tempName });
						if (!item.visuel) item.visuel = {};
						item.visuel.front = a.front;

					}
					const dropzoneUnHelper = new DropzoneUnHelper();

					const options = {
						url: "dropzone/temp/" + tempName,
						resizeWidth: 420,
						resizeHeight: 360,
						resizeMethod: "contain",
					};
					dropzoneUnHelper.lance("Editer le visuel", options, onSuccess);
				},
				t(value) {
					return traduit(value, "global");
				}
			},

			mounted() {

			}
		});

		THIS.vm = app.mount(THIS.c$('._vueChargement')[0]);

	},


	enregistreImg: async function (_id, img) {

	},
	reprise: async function (ecran, echangeur) {
		const THIS = this;
		const data = await this.rest('b2b.env.get', echangeur.hash);

		const k = echangeur.hash.u;
		if (k) this.vm.$data.universe = await this.rest('b2b.env.edit', { k });
		//
		const linelists = data.env.linelists;
		const mains = linelists.filter(u => !u.parent);
		const customs = linelists.filter(u => u.parent);
		this.vm.$data.environnement.sectionMains = triSection(mains);
		this.vm.$data.environnement.sectionCustoms = triSection(customs);
		//
		THIS.$$dic = new $$Dic(data.$$dic);
		//
		this.toggle(true);
		ecran.restaure();
		//
	}
});


export default {
	env: { js: jsEnv, html: htmlEnv }
};

